import { render } from "./SystemSetting.vue?vue&type=template&id=c99aed2c&scoped=true"
import script from "./SystemSetting.vue?vue&type=script&lang=js"
export * from "./SystemSetting.vue?vue&type=script&lang=js"

import "./SystemSetting.vue?vue&type=style&index=0&id=c99aed2c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c99aed2c"],['__file',"src/views/h5/common/basedata/setting/SystemSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c99aed2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c99aed2c', __exports__)) {
    api.reload('c99aed2c', __exports__)
  }
  
  module.hot.accept("./SystemSetting.vue?vue&type=template&id=c99aed2c&scoped=true", () => {
    api.rerender('c99aed2c', render)
  })

}


export default __exports__